export default "__VITE_ASSET__10fd5ef5__"